import { EventBus } from './index'

const EVENT_CONFLICT_SYNC_SHOW = 'conflict-sync-show'
const EVENT_CONFLICT_SYNC_HIDE = 'conflict-sync-hide'

export default {
    EVENT_CONFLICT_SYNC_SHOW,
    EVENT_CONFLICT_SYNC_HIDE,
    show(index, project) {
        EventBus.$emit(EVENT_CONFLICT_SYNC_SHOW, {index, project});
    },
    hide() {
        EventBus.$emit(EVENT_CONFLICT_SYNC_HIDE);
    }
}